import * as Utils from "../utils/Config";
import { ApiClient } from "./ApiClient";

export class OrthodonticLkgCfPatientAdministrationApi extends ApiClient {

    unregisterLkgCfPatient(patientId: number, success: () => void, error?: (message: string) => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/orthodonticLkgCfPatientAdministration/unregisterPatient/${patientId}`, undefined, success, error);
    }
}